import * as React from 'react'
import cn from 'classnames'
import styles from './Layout.module.css'
import { LayoutProps } from './Layout.types'

export function Layout<C extends React.ElementType = 'div'>({
  as,
  variant = 'padded',
  overflowXHidden = false,
  className,
  ...props
}: LayoutProps<C>) {
  const Component = as || 'div'

  return (
    <Component
      className={cn(
        styles.layout,
        {
          [styles.variantPadded]: variant === 'padded',
          [styles.variantFullWidth]: variant === 'fullWidth',
          [styles.overflowXHidden]: overflowXHidden,
        },
        className,
      )}
      {...props}
    />
  )
}

export default Layout
